import { render } from "./RefundsPage.vue?vue&type=template&id=770fa756&ts=true"
import script from "./RefundsPage.vue?vue&type=script&lang=ts"
export * from "./RefundsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__